import React from 'react';
import Popup from "reactjs-popup";
import V3LinkOfferModal from './V3LinkOfferModal';
import ProFormaModal from './ProFormaModal';
import V3SendOfferModal from './V3SendOfferModal';
import CopyOfferModal from './CopyOfferModal';
import V3MobileCreateHoldSheet from './mobile/V3MobileCreateHoldSheet';
import V3PerformerPicker from './V3PerformerPicker';
import V3CreateConfirmModal from './V3CreateConfirmModal';
import { ARTIST_PICKER_MODAL_STYLE } from '../../shared/components/artistPickerModalStyle';

const V3OfferEditModals = ({ ctrl }) => (
  <>
    <Popup
      open={ctrl.linkOfferModalOpen}
      onClose={() => ctrl.setLinkOfferModalOpen(false)}
      modal
      contentStyle={{
        "border": "none",
        "borderRadius": "8px",
        "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
        "width": "700px",
        "maxWidth": "calc(100vw - 16px)",
        "padding": "0"
      }}
      className={"offer-modal"}
      closeOnDocumentClick
    >
      {close => (
        <V3LinkOfferModal
          team={ctrl.team}
          csrfToken={ctrl.csrfToken}
          offer={ctrl.offer}
          onClose={close}
          onSuccess={() => { window.location.reload(); }}
        />
      )}
    </Popup>

    <Popup
      open={ctrl.proFormaOpen}
      onClose={() => ctrl.setProFormaOpen(false)}
      modal
      contentStyle={{
        "border": "none",
        "borderRadius": "8px",
        "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
        "width": "900px",
        "maxWidth": "calc(100vw - 16px)",
        "padding": "0"
      }}
      className={"proforma-modal"}
      closeOnDocumentClick
    >
      {close => (
        <ProFormaModal
          team={ctrl.team}
          offer={ctrl.offer}
          budgetForComponents={ctrl.poolActive ? ctrl.budgetForComponents : ctrl.budgetForMath}
          onClose={close}
        />
      )}
    </Popup>

    <V3SendOfferModal
      isOpen={ctrl.showSendModal}
      onClose={() => ctrl.setShowSendModal(false)}
      sendTo={ctrl.sendTo}
      onChangeSendTo={ctrl.setSendTo}
      sendMessage={ctrl.sendMessage}
      onChangeSendMessage={ctrl.setSendMessage}
      isSendingOffer={ctrl.isSendingOffer}
      onSubmit={ctrl.handleSubmitSend}
    />

    <CopyOfferModal
      isOpen={ctrl.copyModalOpen}
      isCopying={ctrl.isCopying}
      offer={ctrl.offer}
      confirm={ctrl.confirm}
      team={ctrl.team}
      onClose={ctrl.handleCancelCopy}
      onCopy={ctrl.handleSubmitCopy}
    />

    <V3MobileCreateHoldSheet
      open={ctrl.holdSheetOpen}
      onClose={() => ctrl.setHoldSheetOpen(false)}
      team={ctrl.team}
      offer={ctrl.offer}
      csrfToken={ctrl.csrfToken}
      rooms={ctrl.team?.rooms || []}
      venueOwnerships={ctrl.team?.venue_ownerships || []}
      existingHoldPositions={ctrl.confirm?.type === 'Hold' ? (ctrl.confirm?.hold_positions || []) : []}
      onSubmit={async (payload) => {
        await ctrl.handleCreateHold(payload);
        ctrl.setHoldSheetOpen(false);
      }}
    />

    <Popup
      open={ctrl.changeArtistOpen}
      onClose={() => ctrl.setChangeArtistOpen(false)}
      modal
      contentStyle={ARTIST_PICKER_MODAL_STYLE}
      className={"offer-modal"}
      closeOnDocumentClick
    >
      {close => (
        <V3PerformerPicker
          mode="edit"
          variant="modal"
          currentPerformer={ctrl.offer.primary_performer}
          teamId={ctrl.team?.id}
          onSubmit={ctrl.handleChangeArtistPick}
          onClose={close}
        />
      )}
    </Popup>

    <Popup
      open={ctrl.addArtistOpen}
      onClose={() => ctrl.setAddArtistOpen(false)}
      modal
      contentStyle={ARTIST_PICKER_MODAL_STYLE}
      className={"offer-modal"}
      closeOnDocumentClick
    >
      {close => (
        <V3PerformerPicker
          mode="add-sibling"
          allowTba
          variant="modal"
          teamId={ctrl.team?.id}
          description="Add another artist to this event's lineup — a sibling offer is created for them."
          onSubmit={ctrl.handleAddArtistPick}
          onClose={close}
        />
      )}
    </Popup>

    <Popup
      open={ctrl.createConfirmOpen}
      onClose={() => ctrl.setCreateConfirmOpen(false)}
      modal
      contentStyle={{
        border: "none",
        borderRadius: "8px",
        boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
        width: "560px",
        maxWidth: "calc(100vw - 16px)",
        padding: "0"
      }}
      className={"offer-modal"}
      closeOnDocumentClick
    >
      {close => (
        <V3CreateConfirmModal
          team={ctrl.team}
          csrfToken={ctrl.csrfToken}
          offer={ctrl.offer}
          onClose={close}
          onSuccess={(data) => { if (data && data.url) { window.location.href = data.url; } }}
        />
      )}
    </Popup>
  </>
);

export default V3OfferEditModals;
